import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from "@angular/core";
import { ClientService } from "../../../_services/client.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";

@Component({
  selector: "client-incidents",
  templateUrl: "./client-incidents.component.html",
  styleUrls: ["./client-incidents.component.css"],
})
export class ClientIncidentsComponent implements OnInit, OnChanges {
  @Input() offerId: number;
  @Output() created: EventEmitter<number> = new EventEmitter<number>();

  private incidents: object[];
  private creating: boolean = false;

  new_incident = new FormGroup({
    source: new FormControl(),
    content: new FormControl("", [Validators.required]),
  });

  constructor(private service: ClientService) {}

  ngOnInit() {
    this.getIncidentList();
  }

  ngOnChanges() {
    this.getIncidentList();
  }

  getIncidentList() {
    this.service.getIncidents(this.offerId).subscribe((response) => {
      this.incidents = response;
    });
  }

  setContent(event) {
    var value = event.target.value;
    this.new_incident.patchValue({ content: value });
  }

  editIncident(event) {
    event.target.parentElement.getElementsByClassName(
      "no-edit-incident"
    )[0].style = "display: none;"; // Hide the displayed Task
    event.target.parentElement.getElementsByClassName(
      "edit-incident"
    )[0].style = "display: auto;"; // Show it's edit Form
    event.target.parentElement
      .getElementsByClassName("edit-incident")[0]
      .getElementsByTagName("INPUT")[0]
      .focus(); // Focus the Input
    event.target.parentElement
      .getElementsByClassName("edit-incident")[0]
      .getElementsByTagName("INPUT")[0]
      .select(); // Select the content to direct edit
  }

  validEdit(event) {
    if (event.keyCode === 13) {
      // If ENTER pressed, trigger the click on the Update button
      event.target.parentElement.getElementsByTagName("BUTTON")[0].click();
    }
  }

  addIncident(event) {
    this.creating = true;
  }

  createIncident(event) {
    this.service.createIncident({
        id: this.offerId,
        content: this.new_incident.value.content,
        source: this.new_incident.value.source
      })
      .subscribe((response) => {
        this.getIncidentList();
        this.new_incident.patchValue({ content: "" ,source:""});
        event.target.parentElement.parentElement.style = "display: none;";
        this.created.emit(this.incidents.length);
        this.creating = false;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/client/client-incidents/client-incidents.component.ts